export default function switchTheme(theme) {
    const styleFileName = require(`./${theme}`).default;
    const root = document.documentElement;
    Object.entries(styleFileName).forEach(([key, value]) => {
        root.style.setProperty(key, value);
    });
    document.body.style.backgroundColor = theme === 'light' ? '#f7f4f4bb' : '#4D535C'
}
